import styled from 'styled-components';

export const GaugeWrapper = styled('div')`
  width: 300px;
  margin: 0 auto;
`;
